import { NonIndexRouteObject, RouteObject } from 'react-router-dom';

import ErrorBoundary from '../components/errorBoundary';
import Layout from '../components/layout';
import Landing from '../components/landing';
import { SupportSearchVariant } from '../components/supportSearch/definitions/types';

import LegacyRedirect from '../components/legacyRedirect';

// @todo - Add fallback page for these routes
export const appRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Layout
        searchProps={{
          variant: SupportSearchVariant.withIllustration,
        }}
      />
    ),
    errorElement: (
      <Layout
        searchProps={{
          variant: SupportSearchVariant.withIllustration,
        }}
        outletOverride={<ErrorBoundary />}
      />
    ),
    children: [{ index: true, element: <Landing /> }],
  },
  {
    path: '/chat/:chatId',
    element: <Layout />,
    errorElement: (
      <Layout
        searchProps={{
          variant: SupportSearchVariant.withIllustration,
        }}
        outletOverride={<ErrorBoundary />}
      />
    ),
    children: [{ index: true, element: <Landing /> }],
  },
  {
    path: '/hc/en-us/*',
    element: <LegacyRedirect />,
  },
  {
    element: (
      <Layout
        searchProps={{ variant: SupportSearchVariant.withOutIllustration }}
      />
    ),
    errorElement: (
      <Layout
        searchProps={{ variant: SupportSearchVariant.withOutIllustration }}
        outletOverride={<ErrorBoundary />}
      />
    ),
    children: [
      {
        path: '/search',
        index: true,
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { DeflectionSearchResults } = await import(
            '../components/deflectionSearchResults'
          );
          return { Component: DeflectionSearchResults };
        },
      },
      {
        path: '/articles/:articleSlug',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { Article } = await import('../components/article');
          return { Component: Article };
        },
      },
      {
        path: '/submit',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { TicketSubmission } = await import(
            '../components/ticketSubmission'
          );
          return { Component: TicketSubmission };
        },
      },
      {
        path: '/categories/:categoryId',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { CategoryView } = await import('../components/categoryView');
          return { Component: CategoryView };
        },
      },
      {
        path: '/sections/:sectionId',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { SectionView } = await import('../components/sectionView');
          return { Component: SectionView };
        },
      },
    ],
  },
  {
    element: <Layout />,
    errorElement: <Layout outletOverride={<ErrorBoundary />} />,
    children: [
      {
        path: 'tickets/:ticketId',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { TicketDetails } = await import('../components/ticketDetails');
          return { Component: TicketDetails };
        },
      },
      {
        path: '/tickets',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { TicketHistory } = await import('../components/ticketHistory');
          return { Component: TicketHistory };
        },
      },
      {
        path: '/support-plans',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { SupportPlans } = await import('../components/supportPlans');
          return { Component: SupportPlans };
        },
      },
      {
        path: '/accounts',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { AccountSwitcher } = await import(
            '../components/accountSwitcher'
          );
          return { Component: AccountSwitcher };
        },
      },
      {
        path: '/subaccounts',
        lazy: async (): Promise<NonIndexRouteObject> => {
          const { Subaccounts } = await import('../components/subaccounts');
          return { Component: Subaccounts };
        },
      },
    ],
  },
];
